import { Actions } from './depotGestionActions';

/**
 * Etat initial
 */
const initialState = {
    depotsGestion: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour le domaine "depotGestion"
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {

        case Actions.FETCH_DEPOTS_GESTION_REQUEST:
            return {
                ...state,
                depotsGestion: { ...state.depotsGestion, isLoading: true }
            };
        case Actions.FETCH_DEPOTS_GESTION_SUCCESS:
            return {
                ...state,
                depotsGestion: { ...state.depotsGestion, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_DEPOTS_GESTION_FAILURE:
            return {
                ...state,
                depotsGestion: { ...state.depotsGestion, isLoading: false, error: action.error }
            };


        default:
    }

    return state;
};

export default reducer;